module.exports = __webpack_public_path__ + "img/calendar_2.fe5dfcf1.svg";